import { Thread as UnifiedThread } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v2/models.pb';
import { CachedResourceType, CachedEndpointData, QueryResourceIndexes, ResourceMatchingOptions } from '../types';
import { combinedUnifiedThreadMatchFn } from './combined-resource-match-functions';

type GetUnifiedListThreadsResourceIndexesArgs<ResourceType extends CachedResourceType> = {
  data: CachedEndpointData<'ListUnifiedThreads'>;
} & Omit<ResourceMatchingOptions<ResourceType>, 'updater'>;

export const getListUnifiedThreadsResourceIndexes = ({
  data,
  matchValues,
  matchFn,
  matchStrategy = 'and',
}: Omit<
  GetUnifiedListThreadsResourceIndexesArgs<UnifiedThread>,
  'updater'
>): QueryResourceIndexes<'ListUnifiedThreads'> => {
  const matchFunction = combinedUnifiedThreadMatchFn({ matchValues, matchFn, matchStrategy });

  for (let pageIndex = 0; pageIndex < data.pages.length; pageIndex++) {
    const page = data.pages[pageIndex];
    if (!page) continue;

    for (let threadIndex = 0; threadIndex < page.threads.length; threadIndex++) {
      const thread = page.threads[threadIndex];
      if (!thread) continue;

      if (matchFunction(thread)) {
        return { pageIndex, threadIndex };
      }
    }
  }

  return { pageIndex: -1, threadIndex: -1 };
};
